module.exports = __webpack_public_path__ + "img/logo-white.47546bcb.png";